function ArrowButton({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path
        d="M11.0001 14.1037L5.81738 8.92108L6.78339 7.95508L11.0001 12.1717L15.2167 7.95508L16.1827 8.92108L11.0001 14.1037Z"
        fill="#616161"
      />
    </svg>
  );
}

export default ArrowButton;
